/* KPB JP parts inquiry: text-only, opt-in form prefill. No auto-submit. */
(function () {
  'use strict';
  function prefill() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('kpb_inquiry') !== 'jp_parts') return;
    var value = params.get('kpb_context');
    if (typeof value !== 'string' || !value.trim() || value.length > 600) return;
    if (/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/.test(value)) return;
    var form = document.getElementById('ContactForm');
    var field = document.getElementById('ContactForm-body');
    if (!form || !field || !form.contains(field) || field.value.trim()) return;
    if (form.querySelector('.form__message')) return;
    var lang = (document.documentElement.lang || '').toLowerCase();
    var header = lang.startsWith('zh') ? '商品資訊：' :
      lang.startsWith('en') ? 'Item details:' : '商品情報：';
    field.value = header + '\n' + value.trim();
    // The visitor must review and press Shopify's existing Submit button.
    // No network request, automatic submission, PII URL parameter or logging.
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefill, { once: true });
  } else {
    prefill();
  }
})();
